
import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { initPerformanceMonitoring } from './utils/performanceMonitor'
import { lazyLoadImages } from './utils/imageOptimization'

// Initialize performance monitoring
if (typeof window !== 'undefined') {
  initPerformanceMonitoring();
  
  // Setup lazy loading for images
  window.addEventListener('load', () => {
    lazyLoadImages();
  });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
